import Theme from '@adsk/alloy-react-theme';

export const buttonStyle = {
  ...Theme.typography.labelSmall,
  height: '24px',
  minWidth: '134px',
  padding: '0 8px',
};
